import React from "react";

/**
 * Paleidžia kamerą pagal pasirinktą deviceId (jei yra).
 */
export const startCamera = async (
  videoRef: React.RefObject<HTMLVideoElement | null>,
  streamRef: React.RefObject<MediaStream | null>,
  cameraId?: string
) => {
  const stream = await navigator.mediaDevices.getUserMedia({
    video: cameraId ? { deviceId: { exact: cameraId } } : true,
  });
  streamRef.current = stream;
  if (videoRef.current) {
    videoRef.current.srcObject = stream;
  }
};

/**
 * Sustabdo kamerą ir išvalo stream.
 */
export const stopCamera = (
  videoRef: React.RefObject<HTMLVideoElement | null>,
  streamRef: React.RefObject<MediaStream | null>
) => {
  if (streamRef.current) {
    streamRef.current.getTracks().forEach((track) => track.stop());
    streamRef.current = null;
  }
  if (videoRef.current) {
    videoRef.current.srcObject = null;
  }
};

/**
 * Nufotografuoja kadrą iš video ir išsaugo kaip base64.
 */
export const takePhoto = (
  videoRef: React.RefObject<HTMLVideoElement | null>,
  canvasRef: React.RefObject<HTMLCanvasElement | null>,
  setPhoto: (val: string) => void,
  stopCameraFn: () => void
) => {
  const video = videoRef.current;
  const canvas = canvasRef.current;
  if (!video || !canvas) return;

  const ctx = canvas.getContext("2d");
  if (ctx) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = canvas.toDataURL("image/jpeg", 0.9);
    setPhoto(imageData);
    stopCameraFn();
  }
};

/**
 * Iš naujo paleidžia kamerą (po fotografavimo).
 */
export const restartCamera = (
  setPhoto: (val: string | null) => void,
  videoRef: React.RefObject<HTMLVideoElement | null>,
  streamRef: React.RefObject<MediaStream | null>,
  cameraId?: string
) => {
  setPhoto(null);
  stopCamera(videoRef, streamRef);
  startCamera(videoRef, streamRef, cameraId);
};
